import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from "react-redux"
import {useParams} from 'react-router'
import {Link, Redirect, useHistory} from "react-router-dom"

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import Tooltip from '@mui/material/Tooltip'
import IconHelp from '@material-ui/icons/Help'

import axios from "axios"
import {toast} from "react-toastify"

import {Typography, TextField, Button, Box} from "@material-ui/core"

// import inputLimits from '../../constants/inputLimits'
import {urlApi} from "../../api"
import {loadingToggle} from "../../store/actions/appActions"
import {useStyles} from '../../themes/styles'
import { startTransition } from 'react'
import {readDateTime, sortTimes} from '../../fns/times'

const minNoticeString = "24 hours"
const minNoticeMs = 1000 * 60 *60 * 24  // 24 hours

const fieldsArr = [
  "ossSongInfo",
  "ossSongStyle",
]

let fields = {}
for (let i = 0; i < fieldsArr.length; ++i) {
  fields[fieldsArr[i]] = ""
}

const GiftRedeem = (props) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const classes = useStyles()
  const {idxGift} = useParams()
  const inputLimits = useSelector(state => state.app).dataServer.inputLimits
  const prices = useSelector(state => state.app.dataServer.prices)

  const [email, setEmail] = useState("")
  const [message, setMessage] = useState("")
  const [timeConfirmed, setTimeConfirmed] = useState(null)
  const [date, setDate] = React.useState("")
  const [time, setTime] = React.useState(0)
  const [times, setTimes] = React.useState({})
  const [dates, setDates] = React.useState([])
  const [showCheckout, setShowCheckout] = React.useState(false)
  const [showAdd, setShowAdd] = React.useState(false)
  const [disableSubmit, setDisableSubmit] = React.useState(true)
  const [rescheduled, setRescheduled] = React.useState(true)
  const [dateRedeemed, setDateRedeemed] = React.useState(null)
  const [inputs, setInputs] = React.useState(fields)
  const [errors, setErrors] = React.useState(fields)
  const [giftPurchased, setGiftPurchased] = React.useState([])
  const giftPurchased_ = []

  useEffect(() => {
    window.scrollTo(0,0)
    dispatch(loadingToggle(true))

    window.grecaptcha.ready(function() {
      window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', {action: 'submit'}).then(function(recaptchaToken) {
        axios
        .post(`${urlApi}/oss/getGift`, {recaptchaToken, idxGift}, {"withCredentials": true})
        .then(resp => {
          console.log(resp.data)
          const giftsPurchased = [prices[0].item]
          for (let i = 1; i < prices.length; ++i) {
            if (resp.data.giftPurchased[prices[i].item]) {
              giftsPurchased.push(prices[i].item)
            }
          }
          setGiftPurchased(giftsPurchased)
          setDateRedeemed(resp.data.dateRedeemed)
          dispatch(loadingToggle(false))
        })
        .catch(error => {
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
          })
          dispatch({
            type: "LOADING_TOGGLE",
            isLoading: false,
          })
        })
      })
    })

  },[])

  const blurField = (field) => {
    let blurErrors = {...errors}
    switch (field) {
      case "ossSongInfo":
        blurErrors.ossSongInfo = inputs.ossSongInfo.length ? "" : "Please let us know what you would like your song to be about"
        break
      case "ossSongStyle":
        blurErrors.ossSongStyle = inputs.ossSongStyle.length ? "" : "Please let us know what style you would like your song to be"
        break
      default:
    }
    setErrors(blurErrors)
    checkDisableSubmit(inputs, blurErrors)
  }

  const changeVal = (event, field) => {
    let changeInputs = {...inputs}
    var val = event.target.value
    const max = inputLimits[field].max
    if (val.length > max) {
      val = val.slice(0, max)
    }
    changeInputs[field] = val
    setInputs(changeInputs)
    checkDisableSubmit(changeInputs, errors)
  }

  const checkDisableSubmit = (newInputs, newErrors) => {
    if (false
      || !newInputs.ossSongInfo
      || newErrors.ossSongInfo
      || !newInputs.ossSongStyle
      || newErrors.ossSongStyle
    ) {
      setDisableSubmit(true)
    }
    else {
      setDisableSubmit(false)
    }
  }


  const handleSubmit = () => {
    window.grecaptcha.ready(function() {
      window.grecaptcha.execute('6LcXmlErAAAAAL3x9T9LPbNHUoQHMT5lmEPjc0vN', {action: 'submit'}).then(function(recaptchaToken) {
        axios
        .post(`${urlApi}/oss/redeem`, {recaptchaToken, idxGift, inputs}, {"withCredentials": true})
        .then(resp => {
          dispatch(loadingToggle(false))
          history.push(`/purchase/${idxGift}`)
        })
        .catch(error => {
          toast.error(error.response?.data, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 1000,
          })
          dispatch({
            type: "LOADING_TOGGLE",
            isLoading: false,
          })
        })
      })
    })
  }

  if (dateRedeemed == null) return <></>

  return ( <>
    {dateRedeemed ? <>
      <Typography variant="h5" className={/*getChecked(index) ? classes.textGrey : */""}>
        You redeemed this on:
      </Typography>
      <Typography variant="h4" className={classes.spacing}>
        {readDateTime(dateRedeemed)}
      </Typography>
      <div className={classes.spacing}>
        <Typography variant="h5" component={Link} to={`/purchase/${idxGift}`} className={classes.spacing}>View your appointment</Typography>
      </div>
    </> : <Typography variant="h5" className={classes.spacing}>
      Your package includes:
      <ul>{giftPurchased.map((step, index) => (
        <li key={index} value={step}>{step}</li>
      ))}</ul>
      <Box className={classes.spacing}>
        What would you like your song to be about?
        <Tooltip
        // followCursor={false}
        title={"Tell us about your song! Include details like who it’s for, the occasion, key emotions, inside jokes, or any must-have lyrics or themes. The more details, the more personal your song will be!"}
        >
          <IconHelp className={classes.spacing + " " + classes.spacingLeft}/>
        </Tooltip>
        <TextField
        id="enter-song-info"
        className={classes.spacing}
        label="Song Details"
        variant="outlined"
        fullWidth
        multiline
        minRows={4}
        value = {inputs.ossSongInfo}
        onChange = {(event) => changeVal(event, "ossSongInfo")}
        onBlur = {() => blurField("ossSongInfo")}
        error = {Boolean(errors.ossSongInfo)}
        helperText={errors.ossSongInfo}
        />
        <Typography variant="body1">{inputs.ossSongInfo.length} / {inputLimits.ossSongInfo.max}</Typography>
      </Box>
      <Box className={classes.spacing}>
        What style would you like your song to be?
        <Tooltip
        // followCursor
        title={"Choose a genre or mood for your song—pop, country, rock, jazz, heartfelt, funny, or anything in between! If you’re unsure, describe the vibe you want, and we’ll match it to a style."}
        >
          <IconHelp className={classes.spacing + " " + classes.spacingLeft}/>
        </Tooltip>
        <TextField
        id="enter-song-style"
        className={classes.spacing}
        label="Song Style"
        variant="outlined"
        fullWidth
        value = {inputs.ossSongStyle}
        onChange = {(event) => changeVal(event, "ossSongStyle")}
        onBlur = {() => blurField("ossSongStyle")}
        error = {Boolean(errors.ossSongStyle)}
        helperText={errors.ossSongStyle}
        />
        <Typography variant="body1">{inputs.ossSongStyle.length} / {inputLimits.ossSongStyle.max}</Typography>
      </Box>
      <div className={classes.spacing}>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={disableSubmit}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </Typography>}
    </> )
}

export default GiftRedeem
